import { I18n } from 'react-redux-i18n';

export const SITE_PERMISSIONS = [
  'Admin',
  'Status',
  'AddTags',
  'EditDeleteTags',
  'EditDeleteGroupsCategories'
];

export const getDefaultPermissions = perms => {
  const optionList = [];
  const keys = Object.keys(perms);
  for (let i = 0; i < keys.length; i++) {
    if (perms[keys[i]]) {
      optionList.push(keys[i]);
    }
  }
  return optionList;
};

/* This method will convert the passed permission list object to a new format.
   Format will be String or Object type.
*/
export const getUpdatedPermissions = (updatedPermsList, format) => {
  const newPermissions = SITE_PERMISSIONS.reduce((acc, sitePermission) => {
    if (format === 'String')
      acc[sitePermission] = updatedPermsList[sitePermission] ? 'true' : 'false';
    if (format === 'Object')
      acc[sitePermission] =
        updatedPermsList[sitePermission] === 'true' ? true : false;
    return acc;
  }, {});
  return newPermissions;
};

// This method is to get the permission labels of a user.
export const getPermissionLabels = permissions => {
  const PERMISSIONS_LABEL = {
    Admin: I18n.t('userPermissions.Admin'),
    Status: I18n.t('userPermissions.Status'),
    AddTags: I18n.t('userPermissions.AddTags'),
    EditDeleteTags: I18n.t('userPermissions.EditDeleteTags'),
    EditDeleteGroupsCategories: I18n.t(
      'userPermissions.ADDEDITDELETEGROUPSANDCATEGORIES'
    )
  };

  const newPermissions = permissions.reduce((acc, permission) => {
    acc.push({
      label: PERMISSIONS_LABEL[permission.label],
      value: permission.label
    });
    return acc;
  }, []);
  return newPermissions;
};



// WEBPACK FOOTER //
// ./src/constants/perms.js